/* eslint-disable */

import React from 'react';
import ModalSkeleton from '../ModalSkeleton';
import classes from './ContactSales.module.css';
import { Col, Row } from 'react-bootstrap';
import { MdEmail } from 'react-icons/md';
import { IoMdCall } from 'react-icons/io';
import { RiWhatsappFill } from 'react-icons/ri';
import { Contact } from '../../constant/imagePath';
import { useSelector } from 'react-redux';
const ContactSales = ({ show, setShow, t }) => {
  const { contactDetails } = useSelector((state) => state?.commonReducer);
  return (
    <>
      <style>
        {`
         @media (max-width: 1220px) {
        .modalSkeleton_modal__uqB-E .modal-content{
        width: 90% !important;}}
  @media (max-width: 1440px) {
         .modalSkeleton_modal__uqB-E{
       padding-block: 50px !important;
       }
        }
      
        
    
         @media (max-width: 500px) {
        .modalSkeleton_modal__uqB-E .modal-content{
        width: 100% !important;}}
        
        `}
      </style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        modalClass={classes.main}
        borderRadius={'0px'}
        width={'1200px'}
        header={true}
        headerClass={classes.header}>
        <div className={classes.main}>
          <Row className={[classes.row, 'g-0'].join(' ')}>
            <Col md={12} lg={6} className={classes.col1}>
              <h4>{t('contactSalesModal.title')}</h4>
              <p>{t('contactSalesModal.description')}</p>
              <div className={classes.iconsWrap}>
                <a className="c-p" href={`mailto:${contactDetails?.email}`}>
                  <div className={classes.icon}>
                    <MdEmail size={30} fill="#FFFF" />
                  </div>
                  <p> {t('contactSalesModal.emailUs')}</p>
                </a>
                <a className="c-p" href={`tel:${contactDetails?.phone}`}>
                  <div className={classes.icon}>
                    <IoMdCall size={30} fill="#FFFFFF" />
                  </div>
                  <p>{t('contactSalesModal.callUs')}</p>
                </a>
                <div
                  className="c-p"
                  onClick={() => window.open(`https://wa.me/${contactDetails?.phone}`, '_blank')}>
                  <div className={classes.icon}>
                    <RiWhatsappFill size={30} fill="#FFFFFF" />
                  </div>
                  <p>{t('contactSalesModal.whatsappUs')}</p>
                </div>
              </div>
            </Col>
            <Col md={12} lg={6}>
              <div className={classes.sideImage}>
                <img src={Contact} alt="" />
              </div>
            </Col>
          </Row>
          {/* <div className={classes.footer}></div> */}
        </div>
      </ModalSkeleton>
    </>
  );
};

export default ContactSales;
